import { format } from "date-fns";

export const QUEUE_ACCESSIBLE_STATUSES = ["IS_CONFIRMED", "IS_FULL", "IS_CHECKED"];

export const isQueueAccessible = (statementStatus) =>
  QUEUE_ACCESSIBLE_STATUSES.includes(statementStatus);

export const hasCurrentQueue = (currentQueue) =>
  Array.isArray(currentQueue) && currentQueue.length > 0;

export const isFacultyChanged = (savedFacultyId, newFacultyId) =>
  savedFacultyId != null && newFacultyId != null && savedFacultyId !== newFacultyId;

export const getQueueResetOnFacultyChangeMessage = (currentQueue) => {
  const queueTime = formatQueueTime(currentQueue);

  if (queueTime) {
    return `Вы меняете факультет. Текущая запись в электронную очередь на ${queueTime} будет сброшена. Продолжить?`;
  }

  return "Вы меняете факультет. Текущая запись в электронную очередь будет сброшена. Продолжить?";
};

export const confirmQueueResetOnFacultyChange = ({
  savedFacultyId,
  newFacultyId,
  currentQueue,
}) => {
  if (!isFacultyChanged(savedFacultyId, newFacultyId) || !hasCurrentQueue(currentQueue)) {
    return true;
  }

  return window.confirm(getQueueResetOnFacultyChangeMessage(currentQueue));
};

export const formatQueueTime = (currentQueue) => {
  if (!hasCurrentQueue(currentQueue)) {
    return "";
  }

  const item = currentQueue[0];
  const queueDate = item?.item?.time
    ? format(new Date(item.item.time), "dd.MM.yyyy")
    : "";
  const queueText = item?.item?.text || "";

  if (!queueDate && !queueText) {
    return "";
  }

  return `${queueDate}${queueText ? ` в ${queueText}` : ""}`;
};

export const getQueueHintText = (statementStatus, currentQueue) => {
  const queueTime = formatQueueTime(currentQueue);

  if (queueTime) {
    return `Вы уже записаны в электронную очередь на ${queueTime}.`;
  }

  if (isQueueAccessible(statementStatus)) {
    return "Электронная очередь доступна: выберите удобные дату и время подачи документов.";
  }

  return "Электронная очередь откроется после заполнения всех разделов и отправки заявления на проверку.";
};

export const getQueueBlockedMessage = (statementStatus, currentQueue) => {
  if (hasCurrentQueue(currentQueue) && !isQueueAccessible(statementStatus)) {
    const queueTime = formatQueueTime(currentQueue);
    const bookingPart = queueTime
      ? `Ваша запись на ${queueTime} сохранена, `
      : "Ваша запись сохранена, ";

    return `${bookingPart}но после изменения анкеты необходимо снова заполнить все разделы и отправить заявление на проверку.`;
  }

  return "Электронная очередь будет доступна после заполнения данных во всех разделах и отправки заявления на проверку.";
};
